import { startOfMonth, subMonths } from 'date-fns';
import rangeRight from 'lodash/rangeRight';
export function getLastXMonths(now, num) {
  const startOfThisMonth = startOfMonth(now);
  return rangeRight(num).map(numToSub => subMonths(startOfThisMonth, numToSub));
}